require('./bootstrap');
require('./formio');
require('./quill');
require('./diagram-maker')
require('./copyToClipboardButton');
require('./json-formatter');

global.moment = require('moment');

require('tempusdominus-bootstrap-4');
window.JsDiff, JsDiff = require('diff');

window.ClipboardJS = require('clipboard');
window.introJs = require('intro.js').default;
require('intro.js/introjs.css');

$(function() {
    $('[data-toggle="tooltip"]').tooltip();
});
